export { PhotoModule } from './photo.module';
export { PhotoService } from './services/photo.service';
